const THGTracker = {
  hitEndpoint(url) {
    fetch(url, {mode: 'no-cors'});
  },
  version: 1,
  serverUrl: `${window.location.protocol}//userexperience.thehut.net/Tracker/track`,
  encode: encodeURIComponent,
  send(f, e, a) {
    const d = this.getTime();
    let c = `event=${f}&ref=${this.encode(document.referrer)}`;
    c += this.getSessionIdAndUserUrlParameters();
    c += `&msg=${this.reduceSpaceAndTab(this.encode(e))}`;
    const b = `${a}?i=${d}_${this.version}&${c}`;
    this.hitEndpoint(b);
  },
  reduceSpaceAndTab(a) {
    return a.replace(/(%20)+/g, '%20').replace(/(%09)+/g, '%09');
  },
  getSessionIdAndUserUrlParameters() {
    const b = this.getCookie('chumewe_sess');
    const a = this.getCookie('chumewe_user');
    return (b ? `&sessionId=${b}` : '') + (a ? `&user=${this.encode(a)}` : '');
  },
  sendMsg(b, a) {
    this.send(b, a, `${this.serverUrl}/e`);
  },
  
  // added these methods to support new api endpoints of tracker.
  sendEvent(server, msg) {
    this.sendNewEndpoint(server, msg, 'event');
  },
  
  sendPerformance(server, msg) {
    this.sendNewEndpoint(server, msg, 'performance');
  },
  sendNewEndpoint(server, msg, endpoint) {
    const url = `${server}/${endpoint}?component=checkout&${endpoint}Message=${this.reduceSpaceAndTab(this.encode(msg))}`;
    this.hitEndpoint(url);
  },
  
  sendConversionTables(server, msg, componentDetails) {
    const url = `${server}/event?component=${componentDetails}&eventMessage=${this.reduceSpaceAndTab(this.encode(msg))}`;
    this.hitEndpoint(url);
  },
  
  createCookie(c, e, d) {
    let a = '';
    if (d) {
      const b = this.getDate();
      b.setTime(b.getTime() + (d * 1000));
      a = `; expires=${b.toGMTString()}`;
    }
    document.cookie = `${c}=${e}${a}; path=/`;
  },
  getCookie(c) {
    const b = `${c}=`;
    const a = this.getCookies();
    for (let e = 0; e < a.length; e++) {
      let d = a[e];
      while (d.charAt(0) === ' ') {
        d = d.substring(1, d.length);
      }
      if (d.indexOf(b) === 0) {
        return d.substring(b.length, d.length);
      }
    }
    return null;
  },
  getTime() {
    return new Date().getTime();
  },
  getDate() {
    return new Date();
  },
  initialize() {
    let url = `${this.serverUrl}/t?ref=${this.encode(document.location)}&r=${this.getTime()}`;
    url += this.getSessionIdAndUserUrlParameters();
  
    this.hitEndpoint(url);
  },
  getCookies() {
    return document.cookie.split(';');
  },
};

export default THGTracker;
